// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__9HxW4","opacity-transition":"success_opacity-transition__TCmj2"};